import { ADDRESS_ERRORS } from '../constants';
import { isErrorForced, isStatusValid } from './validators.utils';

const ERROR = ADDRESS_ERRORS.INVALID;
const isInvalidForced = isErrorForced(ERROR);
const isInvalid = isStatusValid(ERROR);

export function AddressInvalidValidator() {
  return {
    require: ['ngModel', '^^form'],
    restrict: 'A',
    link(scope, element, attrs, [modelCtrl, formCtrl]) {
      if (formCtrl) {
        scope.$watch(() => formCtrl.$submitted, () => modelCtrl.$validate());
      }

      modelCtrl.$validators[ERROR] = (modelValue, viewValue) => {
        const value = modelValue || viewValue || {};
        return isInvalidForced(modelCtrl._forced) || isInvalid(value);
      };
    },
  };
}
